import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'highlightSearchTree',
    standalone: false
})
export class HighlightSearchTreePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string, search): any {
    if (search) {
      let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      pattern = pattern
        .split(' ')
        .filter((t) => {
          return t.length > 0;
        })
        .join('|');
      let regex = new RegExp(pattern, 'gi');
      let str = search ? text.replace(regex, (match) => `<b>${match}</b>`) : text;
      return this.sanitizer.bypassSecurityTrustHtml(str);
    } else {
      return text;
    }
  }
}
